import { combineReducers } from 'redux'
import { reducer as oidc } from 'redux-oidc'
import { connectRouter } from 'connected-react-router'
import api from './api'

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  oidc,
  api
})

export default createRootReducer